import React, {Component} from 'react';
const { connect } = require('react-redux');

import '../sass/upload.scss';
import HeaderUpload from '../components/upload/HeaderUpload';
import Footer from '../components/Footer';
import FormReactCheckbox from '../components/FormCheckbox';

class Upload extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            showtext1: false,
            showtext2: false
        }
    }
    toggleShow(elem) {
        (elem == 'showtext1') ? this.setState({showtext1: !this.state.showtext1}) : this.setState({showtext2: !this.state.showtext2});
    }
    render()
    {
        const { showtext1, showtext2 } = this.state;
        let hideClassText1 = 'hide'; let hideClassText2 = 'hide'; let hideText1 = 'Show more'; let hideText2 = 'Show more';
        if(showtext1) {hideClassText1 = ''; hideText1 = "Hide more";}
        if(showtext2) {hideClassText2 = ''; hideText2 = "Hide more";}

        return (
            <div id="wrapper">
                <HeaderUpload />
                <aside className="form-load-films">
                        <div className="content">
                            <div className="flex space-between">
                                <div className="load-img">
                                    <div className="mobile-hide">
                                        <p>Drug your video file here</p>
                                        <div className="load-button">Or add file form..</div>
                                    </div>
                                    <div className="mobile-show">
                                        <div className="load-img-mobile">Choose video file</div>
                                    </div>
                                </div>
                                <div className="text-load-img">
                                    <div className="mobile-hide">
                                        <p>Videos must have following formats: <b>.mpeg, .wmv, .mov</b> or <b>.avi</b> and do no exceed more than <b>300 Mb</b> in size.</p>
                                        <p>Do not submit compressed files: <b>.zip, .rar,</b> etc..</p>
                                        <p>Only good quality videos will be published on this site.</p>
                                    </div>
                                    <div className="mobile-show">
                                        <p>Videos must have following formats: <b>.mpeg, .wmv, .mov</b> or <b>.avi</b> and do no exceed more than <b>300 Mb</b> in size.</p>
                                        <div className={hideClassText1}>
                                            <p> Do not submit compressed files: <b>.zip, .rar,</b> etc..</p>
                                            <p>Only good quality videos will be published on this site.</p>
                                        </div>
                                        <p className="show-more" onClick={()=>this.toggleShow('showtext1')}>{hideText1}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="flex space-between">
                                <div className="form-input">
                                    <form>
                                        <div>
                                            <p className="mobile-hide">Title of your contribution:</p>
                                            <input type="email" type="email" placeholder="e-mail"/>
                                        </div>
                                        <div>
                                            <p className="mobile-hide">Description of your contribution:</p>
                                            <textarea name='text' placeholder="Description"/>
                                        </div>
                                    </form>
                                </div>
                                <div className="text-load-img margin">
                                    <div className="mobile-hide">
                                        <p>A text description is very appreciated by visitors, this text helps us to know you better. It is the same for the text of comments you can add on your photos and video. Take time to describe your contribution and content of your pictures in a few words.</p>
                                        <p>Your title and text are automatically translated into several languages​​, so check your spelling and punctuation to be read and understood by all.</p>
                                    </div>
                                    <div className="mobile-show">
                                        <p>A text description is very appreciated by visitors, this text helps us to know you better. It is the same for the text of comments you can add on your photos and video. Take time to describe your contribution and content of your pictures in a few words.</p>
                                        <div className={hideClassText2}>
                                            <p>Your title and text are automatically translated into several languages​​, so check your spelling and punctuation to be read and understood by all.</p>
                                        </div>
                                        <p className="show-more" onClick={()=>this.toggleShow('showtext2')}>{hideText2}</p>
                                    </div>

                                </div>
                            </div>
                            <div className="confirm-block">
                                <div className="form-input">

                                    <FormReactCheckbox field="confirm" name="I confirm that I am owner of these submitted files. I confirm that models on these materials are over 18 years old." />
                                    <FormReactCheckbox field="authorize" name="I authorize the publication of these files on bobtv.fr" />

                                </div>
                            </div>
                            <button className="load-img-button">Confirm your retribution</button>
                        </div>
                </aside>
                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({

    }),({

    })
)(Upload)


// WEBPACK FOOTER //
// ./src/containers/Upload.js